<app-load-nav [activeMenuItem]="'btl'"></app-load-nav>

<mat-card class="content-card">

  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxFlex="70">

      <div><span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span></div>

      <button style="margin-left: 15px; margin-right: 40px;" mat-raised-button color="" [hidden]="!currentUserIsAdmin() && !currentUserIsFinanceManager()" (click)="goToRefundHistory()">Refund History</button>
      <br />
      <h4>BTL - Refunds</h4>
    </div>

    <div fxFlex="30" class="text-right">

    </div>

  </mat-card-header>


  <app-mat-table-generator #table
                           [saveFilters]=true
                           tableName="bankTransferRefundTable"
                           [useEmbededFilter]="true"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="editEnabled()"
                           [deleteEnabled]="deleteLoadsEnabled()"
                           [multiselectEnabled]="true"
                           [customActions]="customActions"
                           [customQueryParams]="{f: 'refund'}"
                           [rowClassCallback]="getRowClass"
                           [viewLink]="getViewLink"
                           [editLink]="getEditLink"
                           [defaultSortField] = "'createDate'"
                           [defaultSortDirection]="'desc'"
  >
  </app-mat-table-generator>
</mat-card>

